module.exports = __webpack_public_path__ + "assets/09f52831-e1cf-48be-9c1e-2d1577e420b7.fa5a4b5b.svg";